import { date, object, SchemaOf, string } from 'yup';

import { UpdatePauseBillingVariables } from '@/graphql/contracts/_generated_/updatePauseBilling.mutation';


type FieldKeys = Exclude<keyof UpdatePauseBillingVariables, 'contractId' | 'collectible'>;

export type Fields = {
  [key in FieldKeys]: UpdatePauseBillingVariables[key] | '';
};

export type UpdatePauseBillingFields = {
  endDate: Date | string;
  startDate?: Date | string;
  reasonCode: string;
  comment?: null | string;
  reference?: null | string;
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  reasonCode: string()
    .required('You must enter a reason'),

  endDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past')
    .required(),

  comment: string()
    .max(100, 'Must be maximum 100 characters')
    .nullable(),

  reference: string()
    .max(50, 'Must be maximum 50 characters')
    .nullable(),
});
